import ProfileImageUploadStatus from 'components/shared/media/ProfileImageUploadStatus';

class ProfileImageResponseParser {
  parse(response) {
    let profileImage;

    if (this.profileImageIsProcessing(response)) {
      profileImage = {
        url: response.processingImage.url,
        amazonAuthorId: response.processingImage.amazonAuthorId,
        profileImageId: response.processingImage.profileImageId,
        metadata: response.processingImage.metadata,
        status: response.processingImage.status,
      };
    } else if (this.aProfileImageExists(response)) {
      profileImage = {
        url: response.url,
        amazonAuthorId: response.amazonAuthorId,
        profileImageId: response.profileImageId,
        metadata: response.metadata,
      };
    } else { // handles the 404 case, and the case where an image is failed and none has succeeded
      profileImage = {};
    }

    return profileImage;
  }

  profileImageIsProcessing(response) {
    return (
      response
      && response.processingImage
      && response.processingImage.status !== ProfileImageUploadStatus.FAILED
    );
  }

  aProfileImageExists(response) {
    return (response && response.url);
  }
}

export default new ProfileImageResponseParser();
